<template>
  <BuildingSectionCard
    title="Accessibility"
    :form="AccessibilityForm"
    :has-info="Boolean(building.accessibility)"
    :placeholder="{
      title: 'No accessibility details yet',
      subtitle: 'Ramps, elevators and accessible entrances, shared by every unit.',
      buttonText: 'Add accessibility',
    }"
  >
    <!-- Two columns whatever the notes say, so the full-width card keeps its shape -->
    <div class="accessibility">
      <PropertyCheckList :items="items" :columns="3" />
      <PropertyNotes v-if="building.accessibility?.accessibilityNotes" :text="building.accessibility.accessibilityNotes" />
      <Text v-else variant="body-medium" color="tertiary">No notes</Text>
    </div>
  </BuildingSectionCard>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { Text } from '@tallo/design-system';
import { AccessibilityForm, BuildingDto } from '@tallo/investor/property';
import { CheckListItem, PropertyCheckList, PropertyNotes, accessibilityMap } from '@tallo/property';

import BuildingSectionCard from '../../../components/building-section-card.vue';

/** What the building answered about access: a yes reads as a check, a no as struck through */
const props = defineProps<{ building: BuildingDto }>();

const items = computed<CheckListItem[]>(() =>
  Array.from(accessibilityMap, ([key, label]) => ({ label, value: props.building.accessibility?.[key] ?? null })),
);
</script>

<style scoped lang="scss">
@import 'styles/mixins/layout.mixins';

.accessibility {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 22rem;
  gap: var(--t-spacing-lg);
  align-items: start;

  @include mobile {
    grid-template-columns: minmax(0, 1fr);
  }
}
</style>
